/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Grid_Item_FieldInputs */

const cs_builder_grid_item_field = /** @type {(inputs: Builder_Grid_Item_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole`)
};

const en_builder_grid_item_field = /** @type {(inputs: Builder_Grid_Item_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field`)
};

/**
* | output |
* | --- |
* | "Field" |
*
* @param {Builder_Grid_Item_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_grid_item_field = /** @type {((inputs?: Builder_Grid_Item_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Grid_Item_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_grid_item_field(inputs)
	return cs_builder_grid_item_field(inputs)
});